import helperFunctions from '@/utils/helperFunctions';

const toWatch = ['analytics/AV_ANALYTICS_EVENT'];

export default store => {
  store.subscribe((mutation, rootState) => {
    if (toWatch.includes(mutation.type)) {
      try {
        const shiftDigitaPayload = helperFunctions.generateShiftDigitalPayload(
          mutation.payload.product,
          mutation.payload.name,
          rootState
        );

        if (
          shiftDigitaPayload &&
          Object.keys(shiftDigitaPayload).length > 0 &&
          rootState.analytics.shiftDigitalAnalytics
        ) {
          window.sd('dataLayer', shiftDigitaPayload);
          window.sd('send');
        }
      } catch (error) {
        store._vm.$log(
          `Error inside AV analytics shift digital subscriber, business api key: ${JSON.stringify(
            rootState.business.api
          )}`,
          error
        );
      }
    }
  });
};
